import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { Observable } from 'rxjs';

interface IUpdateSeuilDialogObjectProps {
  formObject: DynamicForm;
  action: () => void;
  isUpdateDisabled: Observable<boolean>;
  toggleVisibility: () => void;
}

export const getUpdateSeuilDialogObject = ({
  formObject,
  action,
  isUpdateDisabled,
  toggleVisibility,
}: IUpdateSeuilDialogObjectProps): DialogObject => {
  return {
    title: 'settings.seuils.dialog.update.title',
    description: 'settings.seuils.dialog.update.description',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: formObject,
      },
    },
    actions: [
      {
        label: 'settings.seuils.dialog.update.button',
        onClick: () => action(),
        disabled: isUpdateDisabled,
      },
      {
        label: 'common.cancel',
        onClick: () => toggleVisibility(),
        variant: 'secondary',
      },
    ],
  };
};
